'use strict';

export default {

    fadeInOut(el, fadeType = 'in') {


        el.style.opacity = (fadeType === 'in' ? (el.style.opacity ? el.style.opacity : 0) : (el.style.opacity ? el.style.opacity : 1));

        var last = +new Date();
        var direction = (fadeType === 'in' ? 1 : -1);

        var tick = function() {
            el.style.opacity = +el.style.opacity + (direction * (new Date() - last) / 800);
            last = +new Date();
            if (+el.style.opacity < 1 && fadeType === 'in') {
                (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
            }
            if (+el.style.opacity > 0 && fadeType === 'out') {
                (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
            }
        };

        tick();
    }
};



// WEBPACK FOOTER //
// ./app/utils/effects.js